export class RequisitionStepHistoryEmitter {
	requisitionId: number;
	requisitionStepHistoryId: number;
	actionType: string;
	requisitionStatusId?: number | null;
	buyerUserId?: number | null;
	buyerAssignedByUserId?: number | null;

	constructor() {
		this.requisitionId = -1;
		this.requisitionStepHistoryId = -1;
		this.actionType = "";
	}
}
